import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const BurgerMenuIcon: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg viewBox="0 0 19 13" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" {...props}>
        <path fill={color || "currentColor"} d="M0 .008h18.64V2.34H0zM0 5.134h18.64v2.332H0zM0 10.26h18.64v2.332H0z"/>
    </svg>
);

export default BurgerMenuIcon;